module.exports = __webpack_public_path__ + "img/9788967353131.ece5f5f4.jpg";